import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { TranslateService } from '@ngx-translate/core';

type SnackBarType = {
  type: 'email' | 'success' | 'error' | 'info';
  message: string;
  snackBar: MatSnackBar;
  translate: TranslateService;
  params?: Record<string, string>;
};

export const showSnackBar = ({ type, message, snackBar, translate, params }: SnackBarType) => {
  const horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  const verticalPosition: MatSnackBarVerticalPosition = 'top';
  const icon =
    type === 'success' ? 'assets/images/svg/ic-success.svg' : type === 'error' ? 'assets/images/svg/ic-error.svg' : 'assets/images/svg/ic-info.svg';

  translate.get(message, params).subscribe((translated: string) => {
    const iconSize = type === 'email' ? 24 : 20;

    snackBar.openFromComponent(SnackbarComponent, {
      data: {
        message: translated,
        icon,
        action: '',
        iconSize
      },
      horizontalPosition,
      verticalPosition,
      duration: 5000
    });
  });
};
